import Vue from 'vue'
import Router from 'vue-router'

import WebRouter from './WebRouter'
import MobileRouter from './MobileRouter'
import Config from '../config'

Vue.use(Router)
let router = []

if (Config.IsMobile) {
  router = MobileRouter.routes
} else {
  router = WebRouter.routes
}

export default new Router({
  mode: 'history',
  // base: __dirname,
  routes: router,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js